// Registre de navigation R5 : espaces → pages. Utilisé par la barre latérale, l'accueil et les redirections.
import { Home, Microscope, ShieldPlus, HeartHandshake, Layers, BadgeCheck, BookOpenText, FileText, BookText, ShieldCheck,
  LayoutDashboard, ListChecks, Target, Map, GitCompareArrows, Gauge, Activity, ShieldAlert, Workflow, FilePlus2, FileOutput,
  Users, KeyRound, Settings, FileSpreadsheet, Smartphone, Grid3X3, ClipboardList, Plug, Database } from "lucide-react";

export const ESPACES = [
  { key: "strides", label: "STRIDES", sub: "esp_strides_sub", icon: Microscope, accent: "rose", pages: [
    { slug: "tableau-de-bord", label: "nav_dashboard", icon: LayoutDashboard },
    { slug: "cas", label: "nav_cases", icon: ListChecks },
    { slug: "indicateurs", label: "nav_indicators", icon: Target },
  ] },
  { key: "ghs", label: "EpiC-GHS", sub: "esp_ghs_sub", icon: ShieldPlus, accent: "teal", pages: [
    { slug: "tableau-de-bord", label: "nav_dashboard", icon: LayoutDashboard },
    { slug: "indicateurs", label: "nav_indicators", icon: Target },
  ] },
  { key: "crisis", label: "EpiC-Crisis", sub: "esp_crisis_sub", icon: HeartHandshake, accent: "violet", pages: [
    { slug: "tableau-de-bord", label: "nav_dashboard", icon: LayoutDashboard },
    { slug: "indicateurs", label: "nav_indicators", icon: Target },
  ] },
  { key: "reponse", label: "esp_reponse", sub: "esp_reponse_sub", icon: Layers, accent: "blue", pages: [
    { slug: "vue-d-ensemble", label: "nav_overview", icon: LayoutDashboard },
    { slug: "carte", label: "nav_map", icon: Map },
    { slug: "performance", label: "nav_compare", icon: GitCompareArrows },
    { slug: "coordination", label: "nav_coordination", icon: Gauge },
    { slug: "indicateurs", label: "nav_indicators", icon: Target },
    { slug: "decisions", label: "nav_decisions", icon: ClipboardList, profils: ["direction", "partenaire_lecture"] },
  ] },
  { key: "qualite", label: "esp_qualite", sub: "esp_qualite_sub", icon: BadgeCheck, accent: "emerald", pages: [
    { slug: "moniteur", label: "nav_flowmonitor", icon: Activity },
    { slug: "violations", label: "nav_qc", icon: BadgeCheck },
    { slug: "corrections", label: "nav_quality_field", icon: ShieldAlert },
    { slug: "appariement", label: "nav_matching", icon: GitCompareArrows },
    { slug: "etl", label: "nav_etl", icon: Workflow },
    { slug: "saisie", label: "nav_saisie", icon: FilePlus2, profils: ["admin_si", "data_manager", "superviseur_zone", "agent_terrain"] },
    { slug: "problemes", label: "nav_issues", icon: ShieldAlert },
  ] },
  { key: "analyses", label: "esp_analyses", sub: "esp_analyses_sub", icon: BookOpenText, accent: "orange", pages: [
    { slug: "notebooks", label: "nav_notebooks", icon: BookOpenText },
    { slug: "decisions", label: "nav_decisions", icon: ClipboardList },
    { slug: "utilisation-donnees", label: "nav_datause", icon: Gauge },
  ] },
  { key: "rapports", label: "esp_rapports", sub: "esp_rapports_sub", icon: FileText, accent: "slate", pages: [
    { slug: "livrables", label: "nav_reports", icon: FileText },
    { slug: "dhis2", label: "nav_dhis2", icon: FileOutput, profils: ["admin_si", "data_manager", "coord_projet", "direction"] },
  ] },
  { key: "gouvernance", label: "esp_gouvernance", sub: "esp_gouvernance_sub", icon: BookText, accent: "slate", pages: [
    { slug: "referentiels", label: "nav_governance", icon: BookText },
    { slug: "matrice", label: "nav_matrix", icon: Grid3X3 },
    { slug: "dictionnaire", label: "nav_metadata", icon: BookText },
  ] },
  { key: "admin", label: "esp_admin", sub: "esp_admin_sub", icon: ShieldCheck, accent: "slate", pages: [
    { slug: "comptes", label: "nav_admin", icon: Users },
    { slug: "codes", label: "nav_codes", icon: KeyRound },
    { slug: "sources", label: "nav_koboforms", icon: FileSpreadsheet },
    { slug: "kobo-mapping", label: "nav_kobo_mapping", icon: Plug, profils: ["admin_si"] },
    { slug: "sources-donnees", label: "nav_sources", icon: Database, profils: ["admin_si"] },
    { slug: "guide-kobo", label: "nav_kobo_guide", icon: Smartphone },
    { slug: "parametres", label: "nav_settings", icon: Settings },
  ] },
];

export const HOME = { key: "home", to: "/app", icon: Home };

export const ACCENT = {
  rose: { text: "text-rose-600", bg: "bg-rose-50", border: "border-rose-200", dot: "bg-rose-500" },
  teal: { text: "text-teal-600", bg: "bg-teal-50", border: "border-teal-200", dot: "bg-teal-500" },
  violet: { text: "text-violet-600", bg: "bg-violet-50", border: "border-violet-200", dot: "bg-violet-500" },
  blue: { text: "text-blue-700", bg: "bg-blue-50", border: "border-blue-200", dot: "bg-blue-600" },
  emerald: { text: "text-emerald-700", bg: "bg-emerald-50", border: "border-emerald-200", dot: "bg-emerald-500" },
  orange: { text: "text-orange-600", bg: "bg-orange-50", border: "border-orange-200", dot: "bg-orange-500" },
  slate: { text: "text-slate-700", bg: "bg-slate-100", border: "border-slate-200", dot: "bg-slate-500" },
};

export function visibleEspaces(user) {
  const allowed = user?.acces?.espaces || [];
  const profil = user?.profil;
  return ESPACES.filter((e) => allowed.includes(e.key)).map((e) => ({
    ...e, pages: e.pages.filter((p) => !p.profils || p.profils.includes(profil)),
  })).filter((e) => e.pages.length);
}

export const LEGACY_ROUTES = {
  "/strides": "/app/strides/tableau-de-bord", "/cas": "/app/strides/cas", "/ghs": "/app/ghs/tableau-de-bord",
  "/crisis": "/app/crisis/tableau-de-bord", "/comparaison": "/app/reponse/performance", "/coordination": "/app/reponse/coordination",
  "/carte": "/app/reponse/carte", "/indicateurs": "/app/reponse/indicateurs", "/moniteur": "/app/qualite/moniteur",
  "/qualite": "/app/qualite/violations", "/qualite-terrain": "/app/qualite/corrections", "/appariement": "/app/qualite/appariement",
  "/etl": "/app/qualite/etl", "/saisie": "/app/qualite/saisie", "/notebooks": "/app/analyses/notebooks",
  "/rapports": "/app/rapports/livrables", "/dhis2": "/app/rapports/dhis2", "/gouvernance": "/app/gouvernance/referentiels",
  "/admin": "/app/admin/comptes", "/formulaires": "/app/admin/sources", "/guide-kobo": "/app/admin/guide-kobo", "/parametres": "/app/admin/parametres",
};
